import { createBrowserRouter } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
import LoginFailed from "../../loginFailed/LoginFailed";
import NoRole from "../../norole/NoRole";
import Login from "../Login";
import Home from "../Home";

export const Router = createBrowserRouter([
  {
    element: <PrivateRoutes />,
    children: [
      {
        path: "/",
        element: <Login />,
        exact: true,
      },
      {
        path: "/fleet/survey-tool",
        element: <Login />,
        exact: true,
      },
      {
        path: "/fleet/login",
        element: <Login />,
        exact: true,
      },

      {
        path: "/fleet/survey-tool/home",
        element: <Home />,
        exact: true,
      },
      {
        path: "/fleet/home",
        element: <Home />,
        exact: true,
      },
      {
        path: "/fleet/survey-tool",
        element: <Login />,
        exact: true,
      },
      {
        path: "/fleet/survey-tool/login",
        element: <Login />,
        exact: true,
      },
      {
        path: "*",
        element: <Login />,
        exact: true,
      },
      {
        path: "/fleet/loginfailed",
        element: <LoginFailed />,
      },
      {
        path: "/fleet/norole",
        element: <NoRole />,
      },
    ],
  },
]);
